import constate from "constate";
import { useState } from "react";
const useEditor = () => {
  const [activeEditor, setActiveEditor] = useState(null);
  return {
    activeEditor,
    setActiveEditor
  };
};
const [EditorProvider, useEditorContext] = constate(useEditor);
export {
  EditorProvider,
  useEditorContext
};
